module.exports = __webpack_public_path__ + "media/packs/assets/images/arrow-up-bb27d6f407e3392a2d2e27a75695b6d8.png";